const Hero = () => {
    return (
        <div className="hero_container">
            <p className="hero_headline">Future of AI, Future of Japan</p>
        </div>
    )
}
export default Hero;